import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import { S3Client, PutObjectCommand } from '@aws-sdk/client-s3';
import ReactDOMServer from 'react-dom/server';
import { renderToStaticMarkup } from 'react-dom/server';
import PdfRenderComponent from './PdfRenderComponent'; // Update path

export const generateAndUploadPdf = async (
    customTitle,
    type,
    folderPath = 'Peace Village/patient',
    // Add new parameters needed for PdfRenderComponent
    { relativesList, userDatas, recommend1, recommend2, emergency, formName }
) => {
    try {
        // Create a temporary container for rendering
        const tempContainer = document.createElement('div');
        document.body.appendChild(tempContainer);

        // Render the component to static markup
        const staticMarkup = renderToStaticMarkup(
            <PdfRenderComponent
                relativesList={relativesList}
                userDatas={userDatas}
                recommend1={recommend1}
                recommend2={recommend2}
                emergency={emergency}
                formName={formName}
            />
        );

        // Set the innerHTML of our temp container
        tempContainer.innerHTML = staticMarkup;

        // Store original document title
        const originalTitle = document.title;
        document.title = customTitle;

        // Convert the rendered component to canvas
        const canvas = await html2canvas(tempContainer.firstChild, {
            scale: 1,
            logging: false,
            useCORS: true,
            windowHeight: tempContainer.firstChild.scrollHeight,
            backgroundColor: '#FFFFFF',
            onclone: (clonedDoc) => {
                clonedDoc.body.style.backgroundColor = 'white';
                clonedDoc.querySelectorAll('*').forEach(el => {
                    el.style.boxShadow = 'none';
                    el.style.textShadow = 'none';
                });
            }
        });

        // Restore original title
        document.title = originalTitle;

        // Create PDF
        const pdf = new jsPDF('p', 'mm', 'a4');
        const imgData = canvas.toDataURL('image/jpeg', 0.85);
        const imgWidth = pdf.internal.pageSize.getWidth() - 20; // 10mm margins each side
        const imgHeight = (canvas.height * imgWidth) / canvas.width;

        const pageHeight = pdf.internal.pageSize.getHeight() - 20; // Account for margins
        let position = 0;
        let pageCount = 0;

        while (position < imgHeight) {
            if (pageCount > 0) {
                pdf.addPage();
            }

            const remainingHeight = imgHeight - position;
            const renderHeight = Math.min(remainingHeight, pageHeight);

            pdf.addImage(
                imgData,
                'JPEG',
                10, // x margin
                10, // y margin
                imgWidth,
                renderHeight,
                undefined,
                undefined,
                -position // Crop to show correct portion
            );

            position += pageHeight;
            pageCount++;

            // Prevent infinite loop with sanity check
            if (pageCount > 50) break;
        }

        // If we ended up with just one page that's mostly empty, remove extra pages
        if (pageCount > 1) {
            const lastPageHeight = imgHeight - (position - pageHeight);
            if (lastPageHeight < (pageHeight * 0.2)) { // If last page has less than 20% content
                pdf.deletePage(pageCount); // Remove the mostly empty last page
            }
        }

        // Get PDF as Uint8Array
        const pdfData = pdf.output('arraybuffer');

        const s3Client = new S3Client({
            region: 'ap-southeast-1',
            credentials: {
                accessKeyId: "Y0WWU13PSR9JMDUASN8V",
                secretAccessKey: "DF7tATk9SPB0aGkf8tzXkYcfHaBhl2BQzp3hRcm1",
            },
            endpoint: "https://s3.ap-southeast-1.wasabisys.com",
            forcePathStyle: true
        });

        // Prepare upload parameters
        const fileName = `${customTitle}.pdf`;
        const filePath = `${folderPath}/${customTitle}/${type}/${fileName}`;

        const params = {
            Bucket: "pvdev",
            Key: filePath,
            Body: pdfData,
            ContentType: 'application/pdf',
            ACL: 'private'
        };

        const uploadResponse = await s3Client.send(new PutObjectCommand(params));

        if (uploadResponse.$metadata.httpStatusCode !== 200) {
            throw new Error('Wasabi upload failed');
        }

        // Construct the URL manually
        const fileUrl = `https://s3.ap-southeast-1.wasabisys.com/pvdev/${filePath}`;

        return {
            success: true,
            fileUrl,
            bucket: "pvdev",
            key: filePath,
            fileName
        };
    } catch (error) {
        console.error('PDF generation/upload failed:', error);
        return {
            success: false,
            error: error.message,
            stack: error.stack
        };
    }
};
